import { Component, OnInit, ViewChild, ElementRef, OnDestroy, Output, EventEmitter, Input } from '@angular/core';
import { Canvas } from '@syncfusion/ej2-angular-diagrams';
import * as Topaz from '@webappaloosa/topaz-sig-web';
import { SignatureComponent } from '@syncfusion/ej2-angular-inputs';
import { environment } from 'src/environments/environment';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { IntegrationService } from 'src/app/services/Operations/Integration.service';
import { ISignatureCapture } from '../models/VendorsModel';
import { VendorService } from 'src/app/services/Operations/Vendor.service';
import Swal from 'sweetalert2';
import { ActivatedRoute, Params } from '@angular/router';


@Component({
  selector: 'app-signature-capture',
  templateUrl: './signature-capture.component.html',
  styleUrls: ['./signature-capture.component.scss']
})
export class SignatureCaptureComponent implements OnInit, OnDestroy {
  @Input() vendorId: number; // Receive vendorId from parent
  @Input() marketId: number;
  @Input() MarketAccountReceiptId: number; // Receive AccountReceiptId from parent
  @ViewChild('normalSignatureCanvas', { static: true }) normalSignatureCanvas: ElementRef<HTMLCanvasElement>;
  @Input() VId;

  isTopazSignatureEnabled: boolean = true;

  @Output() dataEmitter = new EventEmitter<any>();
  @Output() isFormDirty = new EventEmitter();
  @ViewChild('TopazCanvas') topazCanvas: ElementRef;
  public toasterConfig: Partial<IndividualConfig>;
  public loaderIcon: Promise<boolean>;
  private subscriptions: Subscription[] = [];
  public SignatureRentalTypes: string[] = [];
  public UseSignaturePad: boolean = false;

  vendorName: any;
  constructor(private toastr: ToastrService,
    private SignatureCaptureService: IntegrationService,
    private vendorService: VendorService,
    private route: ActivatedRoute,
  ) {
    this.toasterConfig = {
      timeOut: 3000,
      positionClass: 'toast-top-right',
      closeButton: true,
      progressBar: true,
    };
  }
  SignatureCapture: ISignatureCapture[] = [];
  private signaturePad: CanvasRenderingContext2D | null = null;
  private topazSignaturePad: CanvasRenderingContext2D | null = null;
  finalInitials = '';
  drawInitials = '';
  signaturePadIsEmpty = true;
  autoGeneratedSign = false;
  firstName: string = '';
  lastName: string = '';
  initials: string = '';
  name: string = '';
  showSignatures = false;
  isTopazSign = false;
  SignBase64String: any;
  tmr: any;
  finalSaveBtn = false;
  isSampleAgreementSeen = false;
  isTopazSoftwareInstalled = true;
  isTopazDeviceConnected = true;
  isDrawSign = true;
  Line1: string;
  Line2: string;  
  public isDailyChecked: boolean = false;
  public isWeeklyChecked: boolean = false;
  public isMonthlyChecked: boolean = false;
  public isCombinedWeeklyChecked: boolean = false;
  public isCombinedMonthlyChecked: boolean = false;
  cnvContext: CanvasRenderingContext2D;
  @Output() getSignatureComponentSign: EventEmitter<any> = new EventEmitter<boolean>();
  vendorInfo; 
  vendorMarketID = "";
  cellPhone = "";
  Email = "";
  Address = "";
  City = "";

  ngOnInit(): void {    
    this.getVendorInfobyId();     
    this.getSignatureComponentSign.emit(true);
    this.initializeSignaturePad(); // Initialize normal signature pad
    this.initializeTopazSignaturePad(); // Initialize Topaz signature pad
  }

  ngAfterViewInit(): void {  
  this.preventBackButtonNavigation();
  }  

  preventBackButtonNavigation() {
    history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', (event) => {
      console.log('popstate event triggered');
      history.pushState(null, '', window.location.href);
      Swal.fire({
        title: 'Warning',
        text: "Don't click the back button in your browser.",
        icon: 'warning',
        confirmButtonText: 'OK'
      }).then(() => {
        history.pushState(null, '', window.location.href);
      });
    });
  }

  ngOnDestroy(): void {    
    // Clean up event listeners
    this.cleanUpEventListeners(this.normalSignatureCanvas.nativeElement);
    this.cleanUpEventListeners(this.topazCanvas.nativeElement);
  }

  private initializeSignaturePad(): void {
    const canvas = this.normalSignatureCanvas.nativeElement;
    this.signaturePad = canvas.getContext('2d');

    // Set up canvas styles
    canvas.width = 620;
    canvas.height = 150;
    this.signaturePad.lineWidth = 2;
    this.signaturePad.strokeStyle = '#000';
    this.signaturePad.lineCap = 'round';

    // Event listeners for drawing
    this.addEventListeners(canvas, false);
  }

  private initializeTopazSignaturePad(): void {
    const canvas = this.topazCanvas?.nativeElement;
    this.topazSignaturePad = canvas.getContext('2d');
    canvas.width = 620;
    canvas.height = 150;
    this.addEventListeners(canvas, true);
  }

  private addEventListeners(canvas: HTMLCanvasElement, isTopaz: boolean): void {
    canvas.addEventListener('mousedown', this.startDrawing.bind(this));
    canvas.addEventListener('mouseup', this.stopDrawing.bind(this));
    canvas.addEventListener('mousemove', this.draw.bind(this));
    canvas.addEventListener('mouseleave', this.stopDrawing.bind(this));
  }

  private cleanUpEventListeners(canvas: HTMLCanvasElement): void {
    canvas.removeEventListener('mousedown', this.startDrawing.bind(this));
    canvas.removeEventListener('mouseup', this.stopDrawing.bind(this));
    canvas.removeEventListener('mousemove', this.draw.bind(this));
    canvas.removeEventListener('mouseleave', this.stopDrawing.bind(this));   
  }

  public drawBegin(): void {
  }

  emitData() {
  // Emit the data to the child component
    this.dataEmitter.emit(this.SignBase64String);
  }

  drawComplete(type: string) {
    this.finalInitials = this.drawInitials;
    this.signaturePadIsEmpty = false;
    this.autoGeneratedSign = false;
    this.name = '';
    this.initials = '';
    this.showSignatures = false;

    if (!this.isTopazSign) {
      this.SignBase64String = Canvas;
    } else {
      Topaz.SetTabletState(0, this.tmr);
      Topaz.SetSigCompressionMode(1);
      Topaz.SetImageXSize(620);
      Topaz.SetImageYSize(174);
      Topaz.SetImagePenWidth(5);
      Topaz.GetSigImageB64((base64: string) => {
        this.SignBase64String = `data:image/png;base64,${base64}`;       
      });
    }
    this.finalSaveBtn = (type === 'Confirm');
  }

  private isDrawing: boolean = false;

  private startDrawing(event: MouseEvent): void {    
    this.isDrawing = true;
    this.isFormDirty.emit(true);
    this.draw(event);
  }

  private stopDrawing(): void {
    this.isDrawing = false;
    this.signaturePad?.beginPath();
  }

  private draw(event: MouseEvent): void {
    if (!this.isDrawing || !this.signaturePad) return;

    this.signaturePad.lineTo(event.offsetX, event.offsetY);
    this.signaturePad.stroke();
    this.signaturePad.beginPath();
    this.signaturePad.moveTo(event.offsetX, event.offsetY);
  }

  // Clear the signature pad
  clearSignature(canvasId: string): void {
    const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas for normal signature
    }
    if (this.isTopazSign) {
      Topaz.ClearTablet(); // Clear the Topaz signature pad      
    } 
  }

saveSignature(canvasId: string): void {
  const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
  if (this.isTopazSign) {
    // Topaz signature pad logic
    Topaz.SetTabletState(0, this.tmr);
    Topaz.SetSigCompressionMode(1);
    Topaz.SetImageXSize(620);
    Topaz.SetImageYSize(174);
    Topaz.SetImagePenWidth(5);
    Topaz.LcdRefresh(0,0,0,620,150);
    // Check if Topaz is ready to get signature
    Topaz.GetSigImageB64((base64: string) => {
      if (base64 == "iVBORw0KGgoAAAANSUhEUgAAAmwAAACuCAYAAACLKlGzAAAAAXNSR0IArs4c6QAACQtJREFUeF7t1rENA0EMA0F+Z+7M7lzGd7HBHHA5MVTA5+4+297vESBAgAABAgQIBAWeu/tt+waziUSAAAECBAgQILDNYHMGBAgQIECAAIG4gMEWL0g8AgQIECBAgIDB5gYIECBAgAABAnEBgy1ekHgECBAgQI")
      {
        base64 = '';
        console.log('Received Base64 from Topaz:', base64);
        if (base64 && base64.trim() !== '') {
          this.SignBase64String = `data:image/png;base64,${base64}`;
          this.emitData();

          // Signature is confirmed/saved
          this.isFormDirty.emit(false);

          Topaz.SetTabletState(0, this.tmr);
          this.isTopazSoftwareInstalled = true;
          this.isTopazDeviceConnected = true;

          // FIX:
          // Execute the remaining Topaz logic only after Confirm
          // and only when a valid signature has been received.
          if (
            this.isTopazSoftwareInstalled &&
            this.finalSaveBtn &&
            base64 &&
            base64.trim() !== ''
          ) {
            this.cnvContext = this.topazCanvas.nativeElement.getContext('2d');

            Topaz.SetTabletComTest(false);
            Topaz.SetTabletState(0, this.tmr);
            Topaz.SetTabletComTest(true);
            Topaz.SetDisplayXSize(245);
            Topaz.SetDisplayYSize(98);
            Topaz.SetJustifyMode(5);
            Topaz.ClearTablet();

            if (this.tmr == null) {
              this.tmr = Topaz.SetTabletState(1, this.cnvContext, 50);
            } else {
              Topaz.SetTabletState(0, this.tmr);
              this.tmr = null;
              this.tmr = Topaz.SetTabletState(1, this.cnvContext, 50);
            }

            this.isDrawSign = false;

            Topaz.ClearTablet();
            Topaz.textToTablet(
              100,
              120,
              10,
              'Thank You For Signing!',
              'Thank You For Signing!'
            );

            Topaz.SetLCDCaptureMode(1);
            Topaz.SetLCDCaptureMode(1);
            Topaz.SetTabletComTest(false);
            Topaz.SetTabletState(0, this.tmr);
          }
        }
      } else {
        console.log('Received Base64 from Topaz:', base64);

        if (base64 && base64.trim() !== '') {
          this.SignBase64String = `data:image/png;base64,${base64}`;
          this.emitData(); // Emit base64 string to parent
          // Signature is confirmed/saved
          this.isFormDirty.emit(false);
          Topaz.SetTabletState(0, this.tmr);
          this.isTopazSoftwareInstalled = true;
          this.isTopazDeviceConnected = true;

          // FIX:
          // Do not execute the tablet reset/reinitialization until
          // the signature has actually been captured and Confirmed.
          if (this.isTopazSoftwareInstalled &&
            this.finalSaveBtn &&
            base64 &&
            base64.trim() !== ''
          ) {
            this.cnvContext = this.topazCanvas.nativeElement.getContext('2d');
            Topaz.SetTabletComTest(false);
            Topaz.SetTabletState(0, this.tmr);
            Topaz.SetTabletComTest(true);
            Topaz.SetDisplayXSize(245);
            Topaz.SetDisplayYSize(98);
            Topaz.SetJustifyMode(5);
            Topaz.ClearTablet();
            if (this.tmr == null) {
              this.tmr = Topaz.SetTabletState(1, this.cnvContext, 50);
            } else {
              Topaz.SetTabletState(0, this.tmr);
              this.tmr = null;
              this.tmr = Topaz.SetTabletState(1, this.cnvContext, 50);
            }
            this.isDrawSign = false;
            Topaz.ClearTablet();
            Topaz.textToTablet(100, 120, 10, 'Thank You For Signing!', 'Thank You For Signing!');
            Topaz.SetLCDCaptureMode(1);
            Topaz.SetLCDCaptureMode(1);
            Topaz.SetTabletComTest(false);
            Topaz.SetTabletState(0, this.tmr);
          }
        } else {
          // Provide the same error message for Topaz as for normal signature
          this.toastr.error('Please provide a signature!', 'Error');
          Topaz.SetTabletComTest(false);
          Topaz.SetTabletState(0, this.tmr);
          Topaz.SetTabletComTest(true);
          Topaz.SetDisplayXSize(245);
          Topaz.SetDisplayYSize(98);
          Topaz.SetJustifyMode(5);
          Topaz.ClearTablet();
          if (this.tmr == null) {
            this.tmr = Topaz.SetTabletState(1, this.cnvContext, 50);
          } else {
            Topaz.SetTabletState(0, this.tmr);
            this.tmr = null;
            this.tmr = Topaz.SetTabletState(1, this.cnvContext, 50);
          }
        }
      }
    });

  } else {
    // Normal signature pad logic
    if (!canvas || this.isCanvasEmpty(canvas)) {
      this.toastr.error('Please provide a signature!', 'Error');
      return;
    }
    // Retrieve base64 data from the HTML canvas
    const base64Image = canvas.toDataURL();
    console.log('Base64 Image from Canvas:', base64Image);
    // Save the base64 image string
    this.SignBase64String = base64Image;
    this.emitData(); // Emit base64 string to parent
    // Signature is confirmed/saved, so form is no longer dirty
    this.isFormDirty.emit(false);
    this.clearSignature(canvasId);
  }
}

  private isCanvasEmpty(canvas: HTMLCanvasElement): boolean {
    const context = canvas.getContext('2d');
    const pixelData = context.getImageData(0, 0, canvas.width, canvas.height);
    return pixelData.data.every(value => value === 0); // Check if all pixels are transparent
  }

  //  Tab change
  onTabChange(event: MouseEvent): void { 
    Topaz.LcdRefresh(0,0,0,620,150);   
    const targetTab = (event.target as HTMLElement).getAttribute('href');
    if (targetTab === '#Signature' && !this.isTopazSign) {
      this.initializeSignaturePad();
    } else if (targetTab === '#SignaturewithSignPad') {
      this.isTopazSign = true;
      this.cnvContext = this.topazCanvas.nativeElement.getContext('2d');     
      this.onTopazSign();      
    }
    this.isTopazSign = targetTab === '#SignaturewithSignPad';
  }

  onTopazSign(): void {
    this.isTopazSoftwareInstalled = true;
    this.isTopazDeviceConnected = true;
    if (this.isTopazSoftwareInstalled) {
      this.cnvContext = this.topazCanvas.nativeElement.getContext('2d');
      Topaz.SetTabletComTest(false);
      Topaz.SetTabletState(0, this.tmr);
      Topaz.SetTabletComTest(true);
      Topaz.SetDisplayXSize(245);
      Topaz.SetDisplayYSize(98);
      Topaz.SetJustifyMode(5);
      Topaz.ClearTablet();
      if (this.tmr == null) {
        this.tmr = Topaz.SetTabletState(1, this.cnvContext, 50);
      } else {
        Topaz.SetTabletState(0, this.tmr);
        this.tmr = null;
        this.tmr = Topaz.SetTabletState(1, this.cnvContext, 50);
      }
      // Check if the tablet is connected
      if (Topaz.GetTabletState() == 0) {
        Topaz.SetTabletState(0, this.tmr);
        Topaz.SetTabletComTest(false);
        this.isTopazDeviceConnected = false;
        setTimeout(() => {
          document.getElementById('drawSignature-tab').click();
        }, 1);
        this.isDrawSign = true;
        this.toastr.error('Signature pad not connected.', 'Failure', this.toasterConfig);
        return;
      } else {
        this.isDrawSign = false;

        this.GetSignatureCapture().then(() => {
          try {
            Topaz.ClearTablet();
            Topaz.SetLCDCaptureMode(1);           
            Topaz.textToTablet(100, 0, 10, 'Please Sign Here', 'Please Sign Here');
            Topaz.SetLCDCaptureMode(1);
            Topaz.textToTablet(0, 20, 50, 'Receipt Number : ' + this.MarketAccountReceiptId, 'Receipt Number : ' + this.MarketAccountReceiptId);
            Topaz.textToTablet(0, 40, 50, 'Vendor Name : ' + this.vendorName, 'Vendor Name : ' + this.vendorName);
            Topaz.textToTablet(0, 60, 50, 'Line 1 : ' + this.Line1, 'Line 1 : ' + this.Line1);
            Topaz.textToTablet(0, 80, 50, 'Line 2 : ' + this.Line2, 'Line 2 : ' + this.Line2);
            Topaz.textToTablet(0, 100, 50, '--------------------------------------------------------------------------------------------------------------------', '--------------------------------------------------------------------------------------------------------------------');
            Topaz.SetLCDCaptureMode(1);
            this.isFormDirty.emit(true);
          } catch (error) {
            console.error('Error displaying message:', error);
          }
          Topaz.SetTabletComTest(false);        
        }).catch(err => {
          console.error('Failed to fetch signature capture data:', err);
        });        
      }
    }   
  }
  
  GetSignatureCapture(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.loaderIcon = Promise.resolve(true);
      this.subscriptions.push(this.SignatureCaptureService.GetSignatureCapture(this.marketId).subscribe((res: any) => {
        if (!res.ok) {
          this.toastr.error($localize`Something went wrong`, $localize`Failed`, this.toasterConfig);
          this.loaderIcon = Promise.resolve(false);
          reject('Failed to fetch signature capture data');
          return;
        }
        const result = res.body;
        this.SignatureCapture = result.map((el, i) => ({
          UseSignaturePad: el.UseSignaturePad,
          Line1: el.Line1,
          Line2: el.Line2,          
          SignatureRentalTypes: el.SignatureRentalTypes
        }));

        if (this.SignatureCapture.length > 0) {
          this.Line1 = this.SignatureCapture[0].Line1;
          this.Line2 = this.SignatureCapture[0].Line2;         
          this.UseSignaturePad = this.SignatureCapture[0].UseSignaturePad;
        }
        this.loaderIcon = Promise.resolve(false);
        resolve();
      }, err => {
        this.loaderIcon = Promise.resolve(false);
        reject(err);
      }));
    });
  }

  showConfirmation(canvasId: string) {
    Swal.fire({
      title: $localize`Process Without Signature?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: $localize`Yes`,
      cancelButtonText: $localize`No`
    }).then((result) => {
      if (result.isConfirmed) {
        Topaz.LcdRefresh(0,0,0,620,150);
        this.saveWithoutSignature(canvasId);               
      }
    });      
   }

 saveWithoutSignature(canvasId: string): void {
    const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
    if (this.isTopazSign) {
      Topaz.SetTabletState(0, this.tmr);
      Topaz.SetSigCompressionMode(1);
      Topaz.SetImageXSize(620);
      Topaz.SetImageYSize(174);
      Topaz.SetImagePenWidth(5);
      Topaz.GetSigImageB64((base64: string) => {
        console.log('Received Base64 from Topaz:', base64);
        this.SignBase64String = `data:image/png;base64,${base64}`;
        this.emitData();
      });
    } else {
      if (canvas) {
        const base64Image = canvas.toDataURL();
        console.log('Base64 Image from Canvas:', base64Image);
        this.SignBase64String = base64Image;
      } else {
       //this.SignBase64String = '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';  // or assign a default value if needed
      this.SignBase64String = "";
      }
      this.emitData();
      this.clearSignature(canvasId);      
          Topaz.ClearTablet();
          Topaz.textToTablet(100, 0, 10, 'Please Sign Here', '');
          Topaz.SetLCDCaptureMode(1);
          Topaz.textToTablet(0, 20, 50, 'Receipt Number : ' + this.MarketAccountReceiptId, ' ' +'');
          Topaz.textToTablet(0, 40, 50, 'Vendor Name : ' + this.vendorName, '' + '');
          Topaz.textToTablet(0, 60, 50, 'Line 1 : ' + this.Line1, ' ' + '');
          Topaz.textToTablet(0, 80, 50, 'Line 2 : ' + this.Line2, '' + '');
          Topaz.textToTablet(0, 120, 50, '--------------------------------------------------------------------------------------------------------------------', '');
          Topaz.SetLCDCaptureMode(1);        
      Topaz.SetTabletComTest(false);
    }
  }
  
  getVendorInfobyId() {    
    this.vendorService.GetVendorById(this.vendorId).subscribe((response) => {
      if (response) {
        this.vendorInfo = response.body;
        this.vendorMarketID = this.vendorInfo.MarketVendorId;
        this.vendorName = this.vendorInfo.VendorName;
        this.cellPhone = this.vendorInfo.CellPhone;
        this.Email = this.vendorInfo.Email;
        this.Address = this.vendorInfo.Address;
        this.City = this.vendorInfo.City;
      }
    }, (err) => {
    });
  }
}
